import { useNavigation } from "@react-navigation/native";

import { StackScreenProps } from "../navigation/types";

export default function useProductFormNavigation() {
  return useNavigation<StackScreenProps<"Tabs">["navigation"]>();
}
